import React from 'react';
import { Box, Typography, Button, alpha } from '@mui/material';
import { motion } from 'framer-motion';

const PageHeader = ({ title, subtitle, action, actionText, icon, children }) => {
  return (
    <motion.div
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Box sx={{
        mb: 4,
        p: 3,
        borderRadius: 3,
        background: 'linear-gradient(135deg, #0A2647 0%, #1a3b5c 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <Box sx={{
          position: 'absolute',
          top: -50,
          right: -50,
          width: 200,
          height: 200,
          background: 'rgba(57, 255, 20, 0.03)',
          borderRadius: '50%'
        }} />
        <Box sx={{
          position: 'absolute',
          bottom: -80,
          left: -80,
          width: 250,
          height: 250,
          background: 'rgba(57, 255, 20, 0.02)',
          borderRadius: '50%'
        }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {icon && (
                <Box sx={{
                  bgcolor: alpha('#39FF14', 0.15),
                  borderRadius: 2,
                  p: 1,
                  display: 'flex'
                }}>
                  {icon}
                </Box>
              )}
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {title}
              </Typography>
            </Box>
            {subtitle && (
              <Typography variant="body2" sx={{ opacity: 0.8, mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {children ? (
            // Se tiver children, renderiza eles (para múltiplos botões)
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {children}
            </Box>
          ) : action && (
            // Se não tiver children, usa o action padrão
            <Button
              variant="contained"
              onClick={action}
              sx={{
                bgcolor: '#39FF14',
                color: '#0A2647',
                fontWeight: 700,
                '&:hover': {
                  bgcolor: '#2ecc11',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 25px rgba(57,255,20,0.3)'
                }
              }}
            >
              {actionText}
            </Button>
          )}
        </Box>
      </Box>
    </motion.div>
  );
};

export default PageHeader;
